import { Drawer, DrawerProps } from "@mui/material";
import { QuickInsightCarousel } from "features/quickInsights";
import { useQuickInsightResults } from "features/quickInsights/hooks/useQuickInsightResults";
import { useEffect, useState } from "react";

interface IQuickInsightsDrawerProps extends DrawerProps {}

function QuickInsightsDrawerContent() {
  const { quickInsightResults, loading: quickInsightResultsLoading } =
    useQuickInsightResults();

  return (
    <QuickInsightCarousel
      insights={quickInsightResults || []}
      loading={quickInsightResultsLoading}
    />
  );
}

function QuickInsightsDrawer({ onClose, open }: IQuickInsightsDrawerProps) {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldLoad(true);
    }
  }, [open]);

  return (
    <Drawer
      anchor={"bottom"}
      onClose={onClose}
      open={open}
      sx={{ width: "100%", bottom: { xs: 54, md: 0 } }}
      PaperProps={{
        sx: {
          width: "100%",
          minWidth: "100%",
          maxWidth: "100%",
          padding: 2,
          paddingTop: 4,
          paddingBottom: 10,
        },
      }}
    >
      {shouldLoad ? <QuickInsightsDrawerContent /> : null}
    </Drawer>
  );
}

export default QuickInsightsDrawer;
